import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const pingIdentity = defineConnector({
  identifier: "pingIdentity",
  name: "Ping Identity",
  tagLine: "Identity and access management",
  logo,
  protocol: "http",
  tags: ["it", "identity"],
  defaultUrlPattern: () =>
    "https://api\\.pingone\\.(com|ca|eu|asia|sg|com\\.au)/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a worker application",
      items: [
        {
          kind: "markdown",
          content:
            "In the [PingOne admin console](https://console.pingone.com), go to **Applications > Applications** and create a new **Worker** application. Enable **Client Credentials** as the grant type.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "select",
          label: "Region",
          required: true,
          defaultValue: "com",
          target: { kind: "configuration", field: "region" },
          options: [
            { value: "com", label: "North America (pingone.com)" },
            { value: "ca", label: "Canada (pingone.ca)" },
            { value: "eu", label: "Europe (pingone.eu)" },
            { value: "asia", label: "Australia – legacy (pingone.asia)" },
            { value: "sg", label: "Singapore (pingone.sg)" },
            { value: "com.au", label: "Australia (pingone.com.au)" },
          ],
          helperText: "The PingOne region for your environment.",
        },
        {
          kind: "input",
          label: "Environment ID",
          required: true,
          placeholder: "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
          target: { kind: "configuration", field: "environmentId" },
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: ({ region, environmentId }) =>
      `https://auth.pingone.${region}/${environmentId}/as/token`,
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_post",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: ({ region, environmentId }) => ({
      url: `https://api.pingone.${region}/v1/environments/${environmentId}/users?limit=1`,
      expectedStatus: [200, 403],
    }),
  },
  publicEnvVars: ({ region, environmentId }) => ({
    PING_IDENTITY_REGION: region || "",
    PING_IDENTITY_ENVIRONMENT_ID: environmentId || "",
  }),
});
